/*
 * @Author: cc
 * @Date: 2019-12-20 18:11:05
 * @LastEditTime: 2021-11-05 17:50:17
 * @LastEditors: tanyaohua
 * @FilePath: \xjmediacloud\app\editingCenter\iWo\myManuscript\personalManuscript\news\news.js
 * @Description: iwo新闻稿（单独嵌入到融合编辑页面中的）
 */

'use strict';
angular.module('iWoPersonalNewsModule', ['util.ueditor', 'mgcrea.ngStrap.scrollspy']).controller('iWoPersonalNewsController', [
    '$element',
    'beforeonload',
    '$scope',
    '$compile',
    '$window',
    '$state',
    '$timeout',
    '$stateParams',
    '$validation',
    '$filter',
    'trsHttpService',
    'initiWoDataService',
    'jsonArrayToStringService',
    'modalDialog',
    '$q',
    'initSingleSelecet',
    'iWoService',
    'myManuscriptService',
    'editingCenterService',
    'initeditctrBtnsService',
    'filterEditctrBtnsService',
    'iWoinitBtnService',
    'iWoBtnService',
    'storageListenerService',
    'localStorageService',
    'editcenterRightsService',
    'ueditorService',
    'sensitiveWordCheckService',
    'editIsLock',
    'processingMaterialService',
    'stockApiService',
    '$sessionStorage',
    'ueditorPlugIn',
    function (
        $element,
        beforeonload,
        $scope,
        $compile,
        $window,
        $state,
        $timeout,
        $stateParams,
        $validationProvider,
        $filter,
        trsHttpService,
        initiWoDataService,
        jsonArrayToStringService,
        modalDialog,
        $q,
        initSingleSelecet,
        iWoService,
        myManuscriptService,
        editingCenterService,
        initeditctrBtnsService,
        filterEditctrBtnsService,
        iWoinitBtnService,
        iWoBtnService,
        storageListenerService,
        localStorageService,
        editcenterRightsService,
        ueditorService,
        sensitiveWordCheckService,
        editIsLock,
        processingMaterialService,
        stockApiService,
        $sessionStorage,
        ueditorPlugIn
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化状态
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
            };
            $scope.status = {
                newsFormError: [],
                // 新增start
                nopayment: false,
                switch: 'manuscriptInfo', // 默认选中稿件信息
                support: {
                    content: '', // 提交给辅助写作的纯文本
                },
                showSearch: false,
                huyan: false,
                zhengwen: false,
                showColor: false,
                // end
                openBtn: true,
                mediaTypes: [],
                selectMediaTypes: {},
                isRequest: false,
                bigFaceSwitch: { status: false },
                sensitiveWordTit: '敏感词校验',
                newsDocSaveMethod: ['savePersonalNews', 'saveReceivedNews'],
                titleRule: 'maxlength=50',
                hasVersionTime: false,
                audioVideoidsArray: [], // 播放音视频临时数组
                isCheckSensitiveWords: false,
                isTrsCheckMenu: true,
                isEditDraft: !!$stateParams.iwometadataid,
                metadataid: $stateParams.iwometadataid,
                showVideoAudioDiv: false, // 初始化音视频所需的div
                isFusionEditor: $state.current.name === 'fusionnews', // 是否来自融合编辑器
                suggestionsPromise: '',
            };
            $scope.data = {
                // 新增start
                userName: '',
                manuscriptFrom: 0,
                articleTitleNum: '',
                fgd: 1,
                listStyle: 1,
                label: 'tufa',
                focusImg: 1,
                wordNum: '',
                focusDesNum: '',
                focusTitleNum: '',
                KEYWORDS: [],
                // end
                copyVersion: [],
                comment: {
                    comment: [],
                    voiceObj: {},
                    hasMore: false,
                    currPage: 1,
                },
                lastVersionid: '',
                selectedVideoArray: [], // 选择的视频
            };
            $scope.uploader = {
                // 新增视频上传功能
                fastVideoTimer: '',
                fastVideoInfo: {}, // 视频快编信息
            };
            // 初始化按钮点击
            $scope.handleBtnClick = function (funname) {
                eval('$scope.' + funname + '()');
            };
            // 获取查看痕迹按钮权限
            editcenterRightsService.initIwoListBtn('iwo.trace').then(function (data) {
                $scope.status.bigFaceRights = !!data['iwo.trace.chakan'] ? 'true' : 'false';
            });
            emitCloseWindow();
            $scope.editFlag = {
                media: 'iwo',
                docType: 'news',
            };
        }

        /**
         * [theFormError description] 获取表单变化
         * @return {[type]} [description]
         */
        $scope.theFormError = function () {
            // 当表单发生变化时会进入方法
            var errorArray = [];
            for (var error in $scope.newsForm.$error) {
                errorArray.push(error);
            }
            $scope.status.newsFormError = $scope.status.newsFormError == undefined ? [] : $scope.status.newsFormError;
            if ($scope.status.newsFormError.length != errorArray.length) {
                // 长度不相等说明表单errorname发生变化
                $scope.status.newsFormError = errorArray;
            }
            return $scope.status.newsFormError; // 返回
        };
        $scope.toggleEditor = function () {
            $scope.status.zhengwen = !$scope.status.zhengwen;
            if ($scope.status.zhengwen) {
                // 隐藏编辑器
                $('.body_manuscript_content').addClass('editorHidden');
            } else {
                $('.body_manuscript_content').removeClass('editorHidden');
            }
        };

     
        /**
         * [emitCloseWindow description]标签页关闭页面时，发送稿件解锁信息给其他页面，协助解锁该稿件
         * @return {[type]} [description]
         */
        function emitCloseWindow() {
            editingCenterService.allAppCloseWindow($scope, { typeName: 'iwo', saveLocal: true });
        }

        /**
         * [initData description] 初始化数据
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            $scope.status.showVideoAudioDiv = false;
            storageListenerService.removeListener('iwo');
            initMediaTypes();
            if (!$scope.status.isFusionEditor) {
                ($stateParams.iwometadataid ? initEditData() : initNewData()).then(function () {
                    beforeonload.beforeonloadAlert($scope);
                });
            }
            initArrayBtn();
        }

        /**
         * [initEditData description] 编辑数据
         * @param {[type]} [dealWithListFun] [description] 融合编辑器下处理list的方法
         * @return {[type]} [description]
         */
        function initEditData(dealWithListFun) {
            var defer = $q.defer();
            $scope.params = {
                serviceid: 'mlf_myrelease',
                methodname: 'getNewsDoc',
                MetaDataId: $stateParams.iwometadataid,
            };
            // 编辑显示大花脸
            iWoService.initData().then(function (data) {
                // 初始化页面参数
                $scope.DOCGENRES = data.DocGenre;
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function (data) {
                    $scope.list = data;
                    $scope.data.remarks = data.REMARKS;
                    document.title = data.TITLE;
                    delete $scope.list.ISBLANK;
                    $scope.list.MEDIATYPES = data.MEDIATYPES_DB;
                    initKeyWords();
                    // 初始化原创类型
                    // 融合编辑器下处理list
                    if ($scope.status.isFusionEditor && angular.isFunction(dealWithListFun)) {
                        dealWithListFun();
                    }
                    // 获取流程版本与操作日志
                    getVersion()
                        .then(function () {
                            return loadDirective();
                        })
                        .then(function () {
                            $scope.status.showVideoAudioDiv = true;
                            defer.resolve();
                        });
                });
                // 获取评审意见
                getComment($stateParams.iwometadataid, $scope.data.comment.currPage);
            });
            return defer.promise;
        }

        /**
         * [initNewData description] 新建数据
         * @param {[type]} [dealWithListFun] [description] 融合编辑器下处理list的方法
         * @return {[type]} [description]
         */
        function initNewData(dealWithListFun) {
            var defer = $q.defer();
            $scope.list = initiWoDataService.initNews();
            initDocgenre();
            initKeyWords();
            if ($state.params.from === 'IM') { // IM聊天记录创建新闻稿
                initDocHtmlContent();
            } else { // 媒资库取稿
                $scope.list.HTMLCONTENT = processingMaterialService.deterMinemateriaType();
            }
            // 融合编辑器下处理list
            if ($scope.status.isFusionEditor && angular.isFunction(dealWithListFun)) {
                dealWithListFun();
            }
            loadDirective().then(function () {
                $scope.status.showVideoAudioDiv = true;
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [initDocPictureList description] 初始化新闻稿稿件内容，主要是因为im可以创建新闻稿，通过localstorage存储稿件内容
         *
         * @return  {[type]}   [return description]
         */
        function initDocHtmlContent() {
            var htmlContent = localStorageService.get('IMMaterial');
            if (htmlContent) {
                localStorageService.remove('IMMaterial');
                Object.assign($scope.list, htmlContent);
            }
        }

        /**
         * [close description]页面关闭
         * @return {[type]} [description]
         */
        $scope.close = function () {
            closeCurrView();
        };

        /**
         * [closeCurrView description]页面关闭
         *
         * @return  {[type]}  [return description]
         */
        function closeCurrView() {
            editingCenterService
                .closeWinow($scope.newsForm.$dirty, ueditorService.contentTranscoding($scope.list) != ueditorService.bindContent())
                .then(
                    function () {
                        save().then(function () {
                            storageListenerService.addListenerToIwo('newsSaved');
                            var opened = $window.open('about:blank', '_self');
                            opened.close();
                        });
                    },
                    function () {
                        var opened = $window.open('about:blank', '_self');
                        opened.close();
                    }
                );
        }
        // 空格增加关键词
        $scope.addkeywords = function (e) {
            if (e.keyCode == 32 && $scope.list.KEYWORDS.indexOf($scope.keywordTxt) < 0) {
                $scope.data.KEYWORDS.push($scope.keywordTxt);
                $scope.keywordTxt = '';
            }
        };

        $scope.removeRelate = function (index, type) {
            if (type === 'rN') {
                $scope.list.RELEVANTNEWS.splice(index, 1);
            } else if (type === 'rOf') {
                $scope.list.RELEVANTOFFICIALS.splice(index, 1);
            }
        };
        // 删除关键词
        $scope.delete = function (record) {
            $scope.list.KEYWORDS.splice(record, 1);
        };
        // 更新状态
        $scope.updateSelection = function (item) {
            $scope.list.MEDIATYPES = item.value;
        };

        /**
         * [updateCKSelection description] 更新发稿单信息
         * @param   {[object]}  list  [list description]  页面数据对象
         * @return  {[type]}          [return description]
         */
        $scope.updateCKSelection = function (list) {
            list.ISNOPAYMENT === '1' ? (list.ISNOPAYMENT = '0') : (list.ISNOPAYMENT = '1');
        };

        /**
         * [manageSaveObjBeforeSave description]在保存前处理保存对象
         * @return {[type]} [description]
         */
        function manageSaveObjBeforeSave() {
            getKeyWords();
            $scope.list.serviceid = 'mlf_myrelease'; // 在编辑时后台为返回服务名
            $scope.list.METHODNAME = $state.params.fromType ? 'saveDeptNews' : $scope.status.newsDocSaveMethod[$stateParams.iwoplatform]; // 部门稿库使用部门稿库的方法
            $scope.list.PLATEFORM = $stateParams.iwoplatform;
            $scope.list.DOCRELTIME = $filter('date')(new Date(), 'yyyy-MM-dd HH:mm').toString();
            $scope.list.ORIGINALTYPE = $scope.data.originType;
            $scope.list.SPECIALDOC = $scope.data.specialDoc;
            $scope.list.CONTRIBUTORSAUTHER = $scope.data.userName;
            $scope.list.DeptmentalDocId = $state.params.departmentaldocid;
            var list = angular.copy($scope.list);
            // 删除多余字段开始
            delete list.RELEVANTNEWS;
            delete list.RELEVANTOFFICIALS;
            delete list.OBJ_VERSION;
            delete list.LOG_OPERATION;
            delete list.FZ_DOCS;
            // 删除多余字段结束
            // 处理发稿单作者信息空数据提交问题
            if (
                angular.isDefined(list.FGD_AUTHINFO[0]) &&
                (!angular.isDefined(list.FGD_AUTHINFO[0].USERNAME) || list.FGD_AUTHINFO[0].USERNAME === '')
            ) {
                list.FGD_AUTHINFO = [];
            }
            // 处理发稿单作者信息空数据提交问题
            // NEWSSOURCES为空时传空字符串
            // list.NEWSSOURCES = !$scope.list.NEWSSOURCES || !$scope.list.NEWSSOURCES.SRCNAME ? '' : angular.copy($scope.list.NEWSSOURCES);
            // JSON对象数组转字符串
            list = jsonArrayToStringService.jsonArrayToString(list);
            list.HTMLCONTENT = list.HTMLCONTENT.replace(
                /_ueditor_page_break_tag_/g,
                "<hr class='pagebreak' noshade='noshade' size='5' style='-webkit-user-select: none;'>"
            );
            return list;
        }

        /**
         * [manageDataAfterSave description]保存操作完成后进行数据处理
         * @param  {[type]} data [description]保存后的返回值
         * @param  {[type]} flag [description]调用保存服务后是否弹出成功窗口判断
         * @return {[type]}      [description]
         */
        function manageDataAfterSave(data, flag) {
            $scope.list.METADATAID = data.METADATAID;
            $scope.list.CHNLDOCID = data.CHNLDOCID;
            $scope.status.isEditDraft = true;
            $stateParams.iwochnldocid = $scope.list.CHNLDOCID;
            $stateParams.iwometadataid = $scope.list.METADATAID;
            // 为父窗口传递成功的稿件id编号
            if (window.opener && window.opener.vuexStore) {
                window.opener.vuexStore.newManuId = data.METADATAID;
            }
            $scope.data.incomeData = [
                {
                    TITLE: $scope.list.TITLE,
                    CHNLDOCID: $stateParams.iwochnldocid,
                    METADATAID: $stateParams.iwometadataid,
                },
            ];
            $scope.status.nopayment = true;
            if (flag) {
                if (!$scope.status.isFusionEditor) {
                    storageListenerService.addListenerToIwo('newsSaved');
                    $state.transitionTo($state.current, $stateParams, {
                        reload: false,
                    });
                }
                if (!$scope.status.isFusionEditor) {
                    $timeout(function () {
                        modalDialog.saveModel('保存成功', '', 'success');
                    }, 500);
                }
            } else {
                $scope.params = {};
            }
        }

        /**
         * [saveContent description] 保存正文
         * @return  {[type]}  [return description]
         */
        function saveContent() {
            if (!$scope.status.isFusionEditor) {
                ueditorService.saveContent($scope.list);
            }
        }

        /**
         * [save description] 保存稿件
         * @param  {[type]} type [description] 是否直接保存
         * @return {[type]}      [description]
         */
        $scope.save = function (type) {
            // 包含本地版本功能的稿件类型做了特殊处理，在进行其他操作时均先做此保存操作，以此来更新本地版本
            type = angular.isDefined(type) ? type : true;
            var defer = $q.defer();
            save(type).then(
                function () {
                    if ($scope.$root.cureditpage && $scope.$root.cureditpage === 'iwonews') {
                        editIsLock.lockDraft($stateParams.iwometadataid);
                        getVersion($scope.list.METADATAID).then(function () {
                            var params = {
                                serviceid: 'mlf_myrelease',
                                methodname: 'getNewsDoc',
                                MetaDataId: $scope.list.METADATAID,
                            };
                            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                                if (typeof UE === 'undefined') {
                                    defer.resolve();
                                    return;
                                }
                                var ue = UE.getEditor('ueditor');
                                ue.ready(function () {
                                    // ue.setAllPageContent(data.HTMLCONTENT); // 保存后刷新页面时按照全分页加载
                                    ueditorService.saveToLocal(
                                        $scope.list.METADATAID,
                                        'iwo',
                                        data.HTMLCONTENT,
                                        $scope.list.HTMLCONTENT,
                                        $scope.data.lastVersionid
                                    );
                                    // 新建稿件完成，加载查看痕迹按钮
                                    editcenterRightsService.initIwoListBtn('iwo.trace').then(function (data) {
                                        $scope.status.bigFaceRights = !!data['iwo.trace.chakan'] ? 'true' : 'false';
                                    });
                                    defer.resolve();
                                });
                            });
                        });
                    } else {
                        getVersion($scope.list.METADATAID).then(function () {
                            ueditorService.saveToLocal($scope.list.METADATAID, 'iwo', $scope.list.HTMLCONTENT, $scope.data.lastVersionid);
                        });
                        defer.resolve();
                    }
                },
                function (msg) {
                    defer.reject(msg); // 第二步
                }
            );
            return defer.promise;
        };

        /**
         * [save description]稿件保存方法
         * @param  {[Boolean]} flag [description]标识
         * @return {[type]}      [description]
         */
        function save(flag) {
            var deferred = $q.defer();
            $scope.status.isedit = !!$stateParams.iwometadataid;
            saveContent();
            $timeout(function () {
                $validationProvider.validate($scope.newsForm.authorForm);
                $scope.newsForm.$pending = {};
                $validationProvider
                    .validate($scope.newsForm)
                    .success(function () {
                        sendRequest(deferred, flag);
                    })
                    .error(function () {
                        editingCenterService.checkSaveError($scope.newsForm, $element, $scope); // 定位输入错的表单位置
                        if (Object.keys($scope.newsForm.$error).length === 1 && $scope.newsForm.$error['SOURCE'] && $scope.$root.cureditpage !== 'iwonews') {
                            sendRequest(deferred, flag); // 如果是稿件来源已经填写，并且表单只有稿件来源这一个错误就认为基础稿已保存成功
                        } else {
                            deferred.reject({ plat: '基础稿' });
                            // 第一步
                        }
                    });
            });
            return deferred.promise;
        }

        /**
         * [sendRequest description] 发送请求
         * @param   {[object]}  defer   [defer description] promise对象
         * @param   {[boolean]}  flag   [flag description] 保存的标志
         * @return  {[type]}            [return description]
         */
        function sendRequest(defer, flag) {
            modalDialog.isSecretInformation(
                $state.params.iwometadataid,
                function () {
                    sensitiveWordCheckService.sensitiveWords($scope).then(
                        function (sensitiveWords) {
                            $scope.list.ISCONTAINSENSITIVEWORDS = !!sensitiveWords.length ? 1 : 0;
                            $scope.list.SENSITIVEWORDS = sensitiveWords;
                            $scope.newsForm.$setPristine();
                            $scope.status.openBtn = false;
                            var list = manageSaveObjBeforeSave();
                            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), list, 'post').then(
                                function (data) {
                                    $scope.status.openBtn = true;
                                    $scope.data.METADATAID = data.METADATAID;
                                    if (!$scope.status.isedit) {
                                        $scope.status.isedit = false;
                                    } else {
                                        $scope.status.isedit = true;
                                    }
                                    if ($scope.data.selectedReport) {
                                        myManuscriptService.relatedReport({
                                            ReportId: $scope.data.selectedReport.NEWREPORTID || 0, // 关联的报题id，删除关联波提关系是传0
                                            MetaDataId: $stateParams.iwometadataid || data.METADATAID, // 稿件id
                                            Title: $scope.list.TITLE, // 稿件名称
                                            MediaType: -1, // 渠道类型参数
                                        });
                                    }
                                    if ($scope.data.selectedTask) {
                                        myManuscriptService.relatedTask({
                                            TaskCommandId: $scope.data.selectedTask.TASKCOMMANDID || 0, // 关联的任务id，删除关联波提关系是传0
                                            MetaDataId: $stateParams.iwometadataid || data.METADATAID, // 稿件id
                                            Title: $scope.list.TITLE, // 稿件名称
                                            MediaType: -1, // 渠道类型参数
                                        });
                                    }
                                    manageDataAfterSave(data, flag);
                                    beforeonload.refresh($scope);
                                    defer.resolve(data);
                                },
                                function (data) {
                                    $scope.status.openBtn = true;
                                    defer.reject(data);
                                }
                            );
                        },
                        function (data) {
                            // 有敏感词，并且点击确定修改敏感词
                            $scope.status.isCheckSensitiveWords = Math.random();
                            defer.reject({
                                plat: '基础稿'
                            });
                        }
                    );
                },
                function () {
                    defer.reject();
                },
                $scope.status.isFusionEditor
            );
        }

        // 共享触发（个人稿库+已收稿库）
        $scope.iWoshare = function () {
            $scope.save(false).then(function (data) {
                saveShare(data.METADATAID, data.CHNLDOCID);
            });
        };
        // 共享触发结束
        /**
         * [saveShare description] 共享函数开始
         * @param   {[type]}  metadataid  [metadataid description]
         * @param   {[type]}  chnldocid   [chnldocid description]
         * @return  {[type]}              [return description]
         */
        function saveShare(metadataid, chnldocid) {
            var shareMethod = ['personalMyShare', 'receivedMyShare'];
            editingCenterService.share(function (data) {
                data.serviceid = 'mlf_myrelease';
                data.methodname = shareMethod[$stateParams.iwoplatform];
                data.ChnlDocIds = chnldocid;
                data.MetaDataIds = metadataid;
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), data, 'post').then(function (data) {
                    modalDialog.alertType('共享成功', '', 'success', false, function () {
                        storageListenerService.addListenerToIwo('newsShared');
                        var opened = $window.open('about:blank', '_self');
                        opened.close();
                    });
                });
            });
        }
        // 共享函数结束
        // 传稿(个人稿库+已收稿库)
        $scope.iWoTransfer = function () {
            $scope.save(false).then(function () {
                draft();
            });
        };

        /**
         * [draft description] 传稿
         * @return  {[type]}  [return description]
         */
        function draft() {
            var menthod = ['personalTransferMetaDatas', 'receivedTransferMetaDatas'];
            myManuscriptService.draft(
                '传稿',
                $scope.data.incomeData,
                function () {
                    storageListenerService.addListenerToIwo('newsPassed');
                    var opened = $window.open('about:blank', '_self');
                    opened.close();
                },
                function () { },
                menthod[$stateParams.iwoplatform]
            );
        }

        /**
         * [getKeyWords description] 获取关键词
         * @return  {[type]}  [return description]
         */
        function getKeyWords() {
            $scope.list.KEYWORDS = '';
            angular.forEach($scope.data.KEYWORDS, function (data, index, array) {
                if (index !== $scope.data.KEYWORDS.length - 1) {
                    $scope.list.KEYWORDS += data.name + ';';
                } else {
                    $scope.list.KEYWORDS += data.name;
                }
            });
        }
        // 组装关键词为数组结束
        /**
         * [initKeyWords description] 初始化关键词
         * @return  {[type]}  [return description]
         */
        function initKeyWords() {
            if (angular.isDefined($scope.list.KEYWORDS) && $scope.list.KEYWORDS !== '') {
                var KEYWORDS = $scope.list.KEYWORDS.split(';');
                $scope.data.KEYWORDS = [];
                angular.forEach(KEYWORDS, function (data, index, array) {
                    $scope.data.KEYWORDS.push({
                        name: data,
                    });
                });
            } else {
                $scope.data.KEYWORDS = [];
            }
        }
        // 检验关键词的总个数和总记录长度
        $scope.invalidTag = function (tag) {
            var reg = /^[^<>\/]*$/;
            if (tag.name.length > 20) {
                $scope.isShowKeywordTips = true;
                $scope.keywordsTips = '单个关键词长度不能超过20';
            }
            if (!reg.test(tag.name)) {
                $scope.isShowKeywordTips = true;
                $scope.keywordsTips = '不能包含特殊字符';
            }
        };
        $scope.checkTag = function (tag) {
            var len = $scope.data.KEYWORDS.length;
            if (len == 10) {
                $scope.isShowKeywordTips = true;
                $scope.keywordsTips = '关键词个数不能超过10个';
                return false;
            } else {
                $scope.keywordsTips = '';
                $scope.isShowKeywordTips = false;
            }
            if (tag.name.indexOf(' ') > -1) {
                var spaceArr = tag.name.split(' ');
                $timeout(function () {
                    $scope.data.KEYWORDS.pop();
                    var containArr = [];
                    for (var j = 0; j < $scope.data.KEYWORDS.length; j++) {
                        containArr.push($scope.data.KEYWORDS[j].name);
                    }
                    for (var i = 0; i < spaceArr.length; i++) {
                        if (containArr.indexOf(spaceArr[i]) < 0 && spaceArr[i] != '') {
                            $scope.data.KEYWORDS.push({ name: spaceArr[i] });
                            containArr.push(spaceArr[i]);
                        }
                    }
                });
            }
        };
        $scope.leave = function () {
            $scope.isShowKeywordTips = false;
        };
        $scope.enter = function () {
            var reg = /^[^<>\/]*$/;
            if (angular.isDefined($scope.KEYWORDTEXT) && (!reg.test($scope.KEYWORDTEXT) || $scope.KEYWORDTEXT.length > 20)) {
                $scope.isShowKeywordTips = true;
            }
        };

        /**
         * [initArrayBtn description] 初始化权限按钮
         * @return  {[type]}  [return description]
         */
        function initArrayBtn() {
            $scope.methodnameArray = ['iwo.personal', 'iwo.received'];
            $scope.dictionaryArray = [iWoBtnService.initIwoPersonBtn(), iWoBtnService.initIwoReceiveBtn()];
            $scope.iWoBtns = iWoinitBtnService.initBtnArrays()[$stateParams.iwoplatform];
            initeditctrBtnsService.initIwoData($scope.methodnameArray[$stateParams.iwoplatform]).then(function (data) {
                initeditctrBtnsService.initBtns(data, $scope.dictionaryArray[$stateParams.iwoplatform]).then((btns) => {
                    $scope.btnStatus = btns;
                    $scope.arrayBtn = filterEditctrBtnsService.filterBtn($scope.btnStatus, $scope.iWoBtns);
                    addBtn();
                });
            });
        }

        /**
         * [addBtn description] 增加保存按钮
         * @return  {[type]}  [return description]
         */
        function addBtn() {
            $scope.arrayBtn.unshift({
                RIGHTINDEX: 'save',
                OPERDESC: '保存',
                OPERNAME: '保存',
                OPERFUN: 'save',
            });
        }

        /**
         * [politicalCommonSense description]正文政治常识校验
         * @return {[type]} [description]
         */
        $scope.politicalCommonSense = function () {
            editingCenterService.checkoutDraft(ueditorService.bindContent()).then(function (data) {
                if (data.content[0].resultInfo.length > 0) {
                    var ue = UE.getEditor('ueditor');
                    ue.setContent(ueditorService.handlingSensitiveInf(data, ue.getContent()));
                }
            });
        };

        /**
         * [initTenantId 获取供稿租户ID（当前环境的新疆日报租户ID）]
         *
         * @return  {[type]}  [return description]
         */
        function initTenantId() {
            let defer = $q.defer();
            let tanantId = localStorageService.get('xjrbTanantId');
            if (tanantId) {
                defer.resolve(tanantId);
                return defer.promise;
            }
            let tenanIdParams = stockApiService.getGongGaoTenantIdParam();
            stockApiService.getGongGaoTenantId(tenanIdParams).then((data) => {
                localStorageService.set('xjrbTanantId', data);
                defer.resolve(data);
            });
            return defer.promise;
        }

        /**
         * [addFinishFlag 在空稿件文章正文第二行加一个（完）字]
         *
         * @return  {[type]}  [return description]
         */
        function addFinishFlag() {
            if ($stateParams.iwometadataid) {
                return;
            }
            initTenantId().then(function (data) {
                let xjrbTenantId = data.replace(/\"/g, '');
                if (xjrbTenantId == $sessionStorage.get('curUserInfo').TENANTID) {
                    let ue = UE.getEditor('ueditor');
                    let htmlContent = ue.getContent();
                    let content = htmlContent + '<p></p><span class="finish-flag">（完）</span>';
                    ue.setContent(content);
                    ue.fireEvent('contentchange');
                }
            });

        }

        /**
         * [loadDirective description] 动态加载指令
         * @return  {[type]}  [return description]
         */
        function loadDirective() {
            var defer = $q.defer();
            editingCenterService.loadManuscriptType($scope, $element); // 加载稿件原创部分
            if ($stateParams.issave === undefined || $stateParams.issave === '0') {
                // 用于融合编辑器的虚拟表单校验，虚拟表单检验不需要加载编辑器
                LazyLoad.js(['./lib/ueditor2/ueditor.config.js?v=11.5', './lib/ueditor2/ueditor.all.js?v=11.8'], function () {
                    var ueditor =
                        '<ueditor class="newEditor" edit-flag="editFlag" form="newsForm" has-content="status.hasContent" versionid = "data.lastVersionid" list="list" infullscreen="status.infullscreen"></ueditor>';
                    ueditor = $compile(ueditor)($scope);
                    $element.find('ueditorLocation').append(ueditor);
                    $scope.status.support.content = $scope.list.CONTENT;
                    var ue = UE.getEditor('ueditor');
                    ue.ready(function () {
                        ue.addListener('keydown', function (type, event) {
                            if (event.keyCode === 13) {
                                // 获取纯文本
                                $scope.status.support.content = ue.getContentTxt();
                            }
                        });
                        // if (!$state.params.iwometadataid) { // 只有个人稿库新建才添加这个逻辑
                        //     ueditorPlugIn.addOriginBeforeHtml(ue);
                        //     ueditorPlugIn.addfinishAfterHtml(ue);
                        // }
                        defer.resolve();
                    });
                    var supportCreation =
                        '<support-creation parent-status="status" has-bigface="{{status.bigFaceRights}}" has-editor="true" big-face-switch="status.bigFaceSwitch" is-news="true" media-type={{\'0\'}} is-check-sensitive-words="status.isCheckSensitiveWords" is-trs-check-menu="status.isTrsCheckMenu" list="list"></support-creation>';
                    supportCreation = $compile(supportCreation)($scope);
                    $element.find('supportcreation').append(supportCreation);
                });
            } else {
                defer.resolve();
            }
            if (!$scope.status.isFusionEditor) {
                var draftList =
                    '<editor-dir list="list"  meta-data-id="{{list.METADATAID}}" editor-json="list.FGD_EDITINFO" editor-form="newsForm"></editor-dir>' +
                    '<editor-auth-dir author="list.FGD_AUTHINFO" originalchildtype="list.ORIGINAL==1&&data.originType==3?1:0"></editor-auth-dir>';
                draftList = $compile(draftList)($scope);
                $element.find('editor').append(draftList);
            }
            return defer.promise;
        }

        /**
         * [getVersion description] 获取流程版本与操作日志
         * @param   {[type]}  id  [id description]
         * @return  {[type]}      [return description]
         */
        function getVersion(id) {
            var deferred = $q.defer();
            var metadataid = angular.isDefined(id) ? id : $stateParams.iwometadataid;
            editingCenterService.getEditVersionTime(metadataid, $scope.page, $scope.data.copyVersion).then(
                function (data) {
                    $scope.data.version = data;
                    $scope.page = data.page;
                    $scope.data.copyVersion = data.copyArray;
                    $scope.status.hasVersionTime = true;
                    $scope.data.lastVersionid = data.lastVersionid;
                    deferred.resolve();
                },
                function () {
                    deferred.resolve();
                }
            );
            return deferred.promise;
        }

        /**
         * [isShowVersion description] 没有操作日志或流程版本时不显示图标和'没有更多'
         * @param  {[type]}  key [description] 操作日志或流程版本的数据
         * @return {Boolean}     [description]
         */
        $scope.isShowVersion = function (key) {
            if (key === undefined) {
                return false;
            } else {
                for (var i in key) {
                    return true;
                }
                return false;
            }
        };

        /**
         * [getLoadMore description]操作日志加载更多
         * @return {[type]} [description]
         */
        $scope.getLoadMore = function () {
            $scope.page.CURRPAGE++;
            getVersion();
        };

        /**
         * [getComment description] 获取评审意见
         * @param   {[type]}  id        [id description]
         * @param   {[type]}  currPage  [currPage description]
         * @return  {[type]}            [return description]
         */
        function getComment(id, currPage) {
            editingCenterService.getComment(id, currPage).then(function (data) {
                if (
                    angular.isDefined($scope.data.comment.comment[$scope.data.comment.comment.length - 1]) &&
                    $filter('date')($scope.data.comment.comment[$scope.data.comment.comment.length - 1].day, 'yyyy-MM-dd').toString() ==
                    $filter('date')(data.comment[0].day, 'yyyy-MM-dd').toString()
                ) {
                    $scope.data.comment.comment[$scope.data.comment.comment.length - 1].times = $scope.data.comment.comment[
                        $scope.data.comment.comment.length - 1
                    ].times.concat(data.comment[0].times);
                    data.comment.shift();
                }
                $scope.data.comment['comment'] = $scope.data.comment['comment'].concat(data.comment);
                $scope.data.comment.hasMore = data.hasMore;
                for (var i in data.voiceObj) {
                    $scope.data.comment.voiceObj[i] = data.voiceObj[i];
                }
            });
        }

        /**
         * [getComment description]获取评审意见
         * @return {[type]} [description]
         */
        $scope.getLoadMoreComment = function () {
            $scope.data.comment.currPage += 1;
            getComment($stateParams.iwometadataid, $scope.data.comment.currPage);
        };

        /**
         * [initMediaTypes description]初始化渠道类型
         * @return {[type]} [description]
         */
        function initMediaTypes() {
            initSingleSelecet.getChannelList().then(function (data) {
                $scope.status.mediaTypes = data;
            });
        }

        /**
         * [initDocgenre description]初始化稿件体裁
         * @return {[type]} [description]
         */
        function initDocgenre() {
            iWoService.initData().then(function (data) {
                $scope.DOCGENRES = data.DocGenre;
                $scope.list.DOCGENRE = angular.copy($scope.DOCGENRES[0]);
            });
        }

        /**
         * [getKeywordsOrAbstract description]获得关键词或者摘要
         * @param  {[str]} type [description]种类
         * @return {[type]}      [description]
         */
        $scope.getKeywordsOrAbstract = function (type) {
            editingCenterService.getKeywordsOrAbstract(type, ueditorService.bindContent()).then(
                function (data) {
                    if (type === 'keywords') {
                        if (data !== '""') {
                            var keywordsArray = data.substring(1, data.length - 1).split(';');
                            var arr = [];
                            angular.forEach(keywordsArray, function (value, key) {
                                arr.push({
                                    name: value,
                                });
                            });
                            $scope.data.KEYWORDS = angular.isArray($scope.data.KEYWORDS) ? $scope.data.KEYWORDS : [];
                            $scope.data.KEYWORDS = $scope.data.KEYWORDS.concat(arr);
                            $scope.data.KEYWORDS = $filter('unique')($scope.data.KEYWORDS, 'name');
                            if ($scope.data.KEYWORDS.length > 10) {
                                $scope.data.KEYWORDS = $scope.data.KEYWORDS.splice(0, 10);
                            }
                        } else {
                            return;
                        }
                    }
                    if (type === 'abstract') {
                        $scope.list.ABSTRACT = data.substring(1, data.length - 1);
                    }
                },
                function (data) { }
            );
        };

        /**
         * [clearAllKeywords description]清空关键词
         * @return {[type]} [description]
         */
        $scope.clearAllKeywords = function () {
            $scope.data.KEYWORDS = [];
        };

        /**
         * [openPersonalVersionTime description] 打开流程版本详情页
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.openPersonalVersionTime = function (item) {
            geRelatedversion($scope.status.metadataid, item.VERSIONNUM).then(function (data) {
                var params = {
                    // 融合
                    metadataid: $scope.status.metadataid,
                    iwoobjectversionid: item.OBJECTVERSIONID,
                    wzobjectversionid: angular.isDefined(data.web) ? data.web.objversionId : '',
                    bzobjectversionid: angular.isDefined(data.paper) ? data.paper.objversionId : '',
                    appobjectversionid: angular.isDefined(data.app) ? data.app.objversionId : '',
                    wxobjectversionid: angular.isDefined(data.wechat) ? data.wechat.objversionId : '',
                    versionum: item.VERSIONNUM,
                };
                item.url = $state.href('editingCenterFusionPersonalVersionTime', params);
                var url = item.url;
                $window.open(url);
            });
        };

        /**
         * [geRelatedversion description] 融合稿获取关联流程版本
         * @param  {[type]} MetaDataId [description]
         * @param  {[type]} num        [description]
         * @return {[type]}            [description]
         */
        function geRelatedversion(MetaDataId, num) {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_fusionmyrelease',
                methodname: 'getObjversionByDoc',
                METADATAID: MetaDataId,
                VersionNum: num,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                deffer.resolve(data);
            });
            return deffer.promise;
        }
        $scope.downloadMediaSrc = function (currMedia) {
            var highestMedia = currMedia.value.streamsMap.h || currMedia.value.streamsMap.m || currMedia.value.streamsMap.l;
            return highestMedia.httpURL;
        };

        /* 融合编辑器额外功能开始*/
        if ($scope.status.isFusionEditor) {
            // 原创声明


            /**
             * [pageCantEdit description] 已提交渠道编辑页不能编辑
             * @param  {[type]} type [description] 稿件信息或属性信息
             * @return {[type]}      [description]
             */
            $scope.pageCantEdit = function (type) {
                $timeout(function () {
                    if (type === 'manuscriptInfo') {
                        var manuHeight = $('.body_manuscript').height();
                        var manuWidth = $('.body_manuscript').width();
                        $('.pageCantEdit')
                            .find('.cantEditPart')
                            .height(manuHeight)
                            .width(manuWidth);
                        $('.body_manuscript').resize(function () {
                            $('.pageCantEdit')
                                .find('.cantEditPart')
                                .height($(this).height());
                        });
                    } else if (type === 'attrInfo') {
                        var attrHeight = $('.body_attr_info').height();
                        var attrWidth = $('.body_attr_info').width();
                        $('.pageCantEdit')
                            .find('.cantEditPart')
                            .height(attrHeight)
                            .width(attrWidth);
                        $('.body_attr_info').resize(function () {
                            $('.pageCantEdit')
                                .find('.cantEditPart')
                                .height($(this).height());
                        });
                    }
                }, 300);
            };

            /**
             * [initData description] 融合编辑器切换渠道时的初始化数据
             * @param {[type]} [dealWithListFun] [description] 融合编辑器下处理list的方法
             * @return {[type]} [description]
             */
            $scope.initData = function (dealWithListFun) {
                var defer = $q.defer();
                if (angular.isDefined($stateParams.iwometadataid)) {
                    initEditData(dealWithListFun).then(function () {
                        defer.resolve();
                    });
                } else {
                    initNewData(dealWithListFun).then(function () {
                        defer.resolve();
                    });
                }
                return defer.promise;
            };

            /**
             * [loadFgd description] 加载发稿单
             * @return {[type]} [description]
             */
            $scope.loadFgd = function () {
                var draftList =
                    '<editor-dir list="list"  meta-data-id="{{list.METADATAID}}" editor-json="list.FGD_EDITINFO" editor-form="newsForm"></editor-dir>' +
                    '<editor-auth-dir author="list.FGD_AUTHINFO" originalchildtype="list.ORIGINAL==1&&data.originType==3?1:0"></editor-auth-dir>';
                draftList = $compile(draftList)($scope);
                $element.find('editor').append(draftList);
            };
        }

        /* 融合编辑器额外功能结束*/
    },
]);
